import { ThemedTitle } from '@refinedev/antd';
import { Avatar } from 'antd';

import { useCountryContext } from '@/contexts/CountryContext';
import { useUiContext } from '@/contexts/UiContext';
import acronex_logo from '@/img/acronex-logo.svg';
import acronex_logo_lg from '@/img/acronex-logo-lg.svg';
import pt_flag from '@/img/pt.svg';

interface AcronexThemedTitleProps {
  customWidth?: number;
}
const AcronexThemedTitle = (props: AcronexThemedTitleProps) => {
  const { isBrasilSelected } = useCountryContext();
  const { customWidth } = props;
  const { isMediumScreen, openSider } = useUiContext();

  return (
    <ThemedTitle
      text=""
      icon={
        <>
          <img
            style={{
              width: customWidth ? customWidth : isMediumScreen ? 120 : openSider ? 120 : 32,
            }}
            src={isMediumScreen ? acronex_logo_lg : openSider ? acronex_logo_lg : acronex_logo}
          />
          {isBrasilSelected && (
            <Avatar
              style={{
                width: 20,
                height: 20,
                position: 'relative',
                top: 8,
                right: 2,
                border: '2px solid #ffffff',
              }}
              size="small"
              src={pt_flag}
              alt="Brazil Flag"
            />
          )}
        </>
      }
      collapsed={!openSider}
    />
  );
};

export default AcronexThemedTitle;
